import Vue from "Vue";
import { MutationTree } from 'vuex';
import {
	IAudioPlayerState,
	AUDIO_PLAYER_STORE_TYPES
} from './audio-player-types.store';


export const mutations: MutationTree<IAudioPlayerState> = {
	[AUDIO_PLAYER_STORE_TYPES.SET_AUDIO_URL]: (state, audioUrl: string) => {
		Vue.set(state, 'audioUrl', audioUrl);
	},
	[AUDIO_PLAYER_STORE_TYPES.SET_TITLE]: (state, title: string) => {
		Vue.set(state, 'title', title);
	},
	[AUDIO_PLAYER_STORE_TYPES.SET_IS_SHOW]: (state, isShow: boolean) => {
		Vue.set(state, 'isShow', isShow);
	},
	[AUDIO_PLAYER_STORE_TYPES.SET_AUDIO_PLAYER]: (state, audioPlayer: Partial<IAudioPlayerState>) => {
		(Object.keys(audioPlayer) as (keyof IAudioPlayerState)[]).forEach(key => {
			Vue.set(state, key, audioPlayer[key]);
		});
	},
	[AUDIO_PLAYER_STORE_TYPES.SET_RECORD_ID]: (state, recordId: number) => {
		Vue.set(state, 'recordId', recordId);
	},
	[AUDIO_PLAYER_STORE_TYPES.SET_IS_PLAYING]: (state, isPlaying: boolean) => {
		if (state.isPlaying === isPlaying) return;
		Vue.set(state, 'isPlaying', isPlaying);
	}
}